// Saved-view filter pickers — read snake_case (canonical) or legacy camelCase.

export function pickRaw(obj: Record<string, unknown>, ...keys: string[]): unknown {
  for (const k of keys) {
    if (obj[k] !== undefined) return obj[k];
  }
  return undefined;
}

export function pickString(obj: Record<string, unknown>, ...keys: string[]): string | null {
  const v = pickRaw(obj, ...keys);
  return typeof v === "string" && v !== "" ? v : null;
}

export function pickNumber(obj: Record<string, unknown>, ...keys: string[]): number | null {
  const v = pickRaw(obj, ...keys);
  return typeof v === "number" ? v : null;
}
